<template>
  <v-container class="mt-4 ml-2" fluid>
    <v-row>
      <v-col cols="12">
        <v-card class="shadowCard">
          <v-card-title primary-title>
            <span class="text-subtitle-1">Mis Grupos</span>
            <v-spacer></v-spacer>

            <v-btn 
              class="mr-2" 
              small dark color="green"
              @click="exportExcel(misGrupos, 'MIS_GRUPOS_ERP')"
              tile
            >
              <v-icon small>mdi-microsoft-excel</v-icon>
            </v-btn>

            <v-btn
              color="primary"
              dark
              class="text-capitalize"
              @click="initialize()"
              small
              tile
            >
              <v-icon left small>mdi-refresh</v-icon>
              Actualizar
            </v-btn>
          </v-card-title>
          
          <v-card-text>
            <v-row justify="end">
              <v-col cols="12" md="6">
                <v-text-field
                  name="name"
                  label="Buscar"
                  id="id"
                  filled
                  dense
                  hide-details
                  append-icon="mdi-magnify"
                  v-model="search"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-data-table
                  :headers="headers"
                  :items="misGrupos"
                  class="elevation-0"
                  :search="search"
                  :mobile-breakpoint="100"
                  dense
                >
                  <template v-slot:item.fechainicio="{ item }">
                    {{ formatDate(item.fechainicio) }}
                  </template>

                  <template v-slot:item.fechafinal="{ item }">
                    {{ formatDate(item.fechafinal) }}
                  </template>

                  <template v-slot:item.actions="{ item }">
                    <v-btn 
                      color="orange" 
                      x-small
                      icon
                      @click="verAlumnos(item)"
                      class="mr-2"
                      title="Ver alumnos"
                    >
                      <v-icon small>mdi-account-group</v-icon>
                    </v-btn>

                    <v-btn 
                      color="blue" 
                      x-small
                      icon
                      @click="alumnosAsistencia(item)"
                      class="mr-2"
                      title="Tomar asistencia"
                    >
                      <v-icon small>mdi-clipboard-account</v-icon>
                    </v-btn>
                  </template>

                  <template v-slot:no-data>
                    <v-btn
                      color="primary"
                      @click="initialize"
                      small
                    >
                      Actualizar
                    </v-btn>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- Diálogo para mostrar alumnos -->
    <v-dialog
      v-model="dialogAlumnos"
      max-width="800px"
      persistent
    >
      <v-card>
        <v-card-title>
          <span class="text-subtitle-1">Alumnos del Grupo</span>
          <v-spacer></v-spacer>
          <span class="text-subtitle-1">
            <strong>Curso: {{ selectedGrupo.curso }}</strong>
          </span>
        </v-card-title>

        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-data-table
                :headers="headersAlumnos"
                :items="alumnos"
                class="elevation-0"
                :mobile-breakpoint="100"
                dense
              >
                <template v-slot:no-data>
                  <div class="text-center">No hay alumnos registrados en este grupo</div>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="closeAlumnos"
          >
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Diálogo para tomar asistencia -->
    <v-dialog
      v-model="dialogAlumnosAsistencia"
      max-width="600px"
      persistent
    >
      <v-card>
        <v-card-title>
          <span class="text-subtitle-1">Tomar asistencia</span>
          <v-spacer></v-spacer>
        </v-card-title>

        <v-card-text>
          <v-row>
            <v-col cols="12" md="8" lg="6">
              <v-menu
                ref="menu"
                v-model="menu"
                :close-on-content-click="false"
                :return-value.sync="fecha_asistencia"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="fecha_asistencia"
                    label="Fecha de asistencia"
                    append-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    filled
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="fecha_asistencia"
                  no-title
                  scrollable
                  :allowed-dates="allowedDates"
                  :min="fechaMin"
                  :max="fechaMax"
                  color="primary"
                >
                  <v-spacer></v-spacer>
                  <v-btn
                    text
                    color="primary"
                    @click="menu = false"
                  >
                    Cancelar
                  </v-btn>
                  <v-btn
                    text
                    color="primary"
                    @click="$refs.menu.save(fecha_asistencia)"
                  >
                    Ok
                  </v-btn>
                </v-date-picker>
              </v-menu>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12">
              <v-radio-group
                row
                value="1"
              >
                <v-radio
                  color="green"
                  value="1"
                  label="Asistencia"
                ></v-radio>
                <v-radio
                  color="red"
                  value="2"
                  label="Falta"
                ></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-data-table
                :headers="headersAlumnosAsistencia"
                :items="listaalumnos"
                :items-per-page="listaalumnos.length"
                class="elevation-0"
                hide-default-footer
                :mobile-breakpoint="100"
              >
                <!-- Valor asistencia -->
                <template v-slot:item.asistencia="{ item }">
                  <div>
                    <v-radio-group
                      row
                      v-model="item.valor_asistencia"
                    >
                      <v-radio
                        color="green"
                        :value="1"
                      ></v-radio>
                      <v-radio
                        color="red"
                        :value="2"
                      ></v-radio>
                    </v-radio-group>
                  </div>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-btn
            icon
            top
            absolute
            right
            @click="dialogAlumnosAsistencia = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>

          <v-spacer></v-spacer>
          <v-btn
            color="green"
            dark 
            block
            outlined
            @click="enviarAsistencias()" 
          >
            <v-icon small left>mdi-content-save</v-icon>
            <span>Guardar</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog de carga -->
    <Alerta v-if="respuestaAlerta" :parametros="parametros"/>
    <carga v-if="cargar"/>

  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';
// Componentes
import Alerta from '@/components/alertas/Alerta.vue';
import carga from '@/components/alertas/carga.vue';

import validarErrores from '@/mixins/validarErrores';
import funcionesExcel from '@/mixins/funcionesExcel';

export default {
  mixins: [validarErrores, funcionesExcel],

  components: {
    Alerta,
    carga,
  },

  data: () => ({
    // Alertas
    parametros: {
      dialogError: false,
      mensaje: '',
      color: ''
    },

    respuestaAlerta: false,
    loader: true,
    cargar: false,

    dialogAlumnos: false,
    dialogAlumnosAsistencia: false,
    
    selectedGrupo: {
      idgrupos: 0,
      curso: '',
    },
    
    // tabla
    search: '',
    page: 1,
    pageCount: 0,
    itemsPerPage: 10,
    misGrupos: [],

    headers: [
      { text: 'ID', value: 'idgrupos' },
      { text: 'Plantel', value: 'plantel' },
      { text: 'Curso', value: 'curso' },
      { text: 'Horario', value: 'horario' },
      { text: 'Inicia', value: 'fechainicio' },
      { text: 'Termina', value: 'fechafinal' },
      { text: 'Acciones', value: 'actions', sortable: false },
    ],

    headersAlumnos: [
      { text: 'ID', value: 'idgruposalumnos' },
      { text: 'Alumno', value: 'alumno' },
      { text: 'Teléfono', value: 'telefono' },
      { text: 'Edad', value: 'edad' },
      { text: 'Correo', value: 'correo' },
    ],

    headersAlumnosAsistencia: [
      { text: 'Alumno', value: 'alumno', class: 'secondaryText--text text-caption sizeFont' },
      { text: 'Asistencia', value: 'asistencia', class: 'secondaryText--text text-caption sizeFont' },
    ],

    alumnos: [],
    listaalumnos: [],
    fecha_asistencia: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
    menu: false,
    fechaMin: null,
    fechaMax: null
  }),

  computed: {
    ...mapGetters('login', ['getdatosUsuario']),
  },

  watch: {
    dialogAlumnos(val) {
      val || this.closeAlumnos()
    },
    
    fecha_asistencia(val) {
      // Si cambia la fecha, actualizar la lista de alumnos con asistencia
      if (this.selectedGrupo.idgrupos > 0) {
        this.alumnosAsistencia(this.selectedGrupo)
      }
    }
  },

  created() {
    this.initialize();
  },

  methods: {
    formatDate(dateString) {
      if (!dateString) return '';
      
      const date = new Date(dateString);
      const day = date.getDate().toString().padStart(2, '0');
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const year = date.getFullYear();

      return `${day}/${month}/${year}`;
    },

    initialize() {
      this.cargar = true;
      this.misGrupos = [];
          
      // Obtener el ID del maestro logueado desde el store
      const idMaestro = this.getdatosUsuario.id;
          
      // Ahora pasamos el ID del maestro en la URL
      return this.$http.get(`mis-grupos.list/${idMaestro}`).then(response => {
        this.misGrupos = response.data;
        this.cargar = false;
      }).catch(error => {
        this.validarError(error);
      }).finally(() => { this.cargar = false; });
    },

    verAlumnos(item) {
      this.selectedGrupo = Object.assign({}, item);
      this.cargar = true;
      
      return this.$http.get(`mis-grupos.alumnos/${item.idgrupos}`).then(response => {
        this.alumnos = response.data;
        this.dialogAlumnos = true;
        this.cargar = false;
      }).catch(error => {
        this.validarError(error);
      }).finally(() => { this.cargar = false; });
    },

    closeAlumnos() {
      this.dialogAlumnos = false;
      this.$nextTick(() => {
        this.alumnos = [];
      });
    },

    allowedDates(val) {
      // Retorna una función que Vuetify usa para filtrar fechas permitidas
      const fecha = new Date(val);
      const inicio = new Date(this.selectedGrupo.fechainicio);
      const fin = new Date(this.selectedGrupo.fechafinal);

      // Validar si está dentro del rango
      if (fecha < inicio || fecha > fin) return false;

      // Obtener el día de la semana (0: domingo, 1: lunes, ..., 6: sábado)
      const diaSemana = fecha.getDay();

      // Mapear a tus variables (asumiendo que el grupo tiene estos campos)
      const diasPermitidos = [
        this.selectedGrupo.domingo,    // 0
        this.selectedGrupo.lunes,      // 1
        this.selectedGrupo.martes,     // 2
        this.selectedGrupo.miercoles,  // 3
        this.selectedGrupo.jueves,     // 4
        this.selectedGrupo.viernes,    // 5
        this.selectedGrupo.sabado      // 6
      ];

      return diasPermitidos[diaSemana] === 1;
    },

    alumnosAsistencia(item) {
      this.selectedGrupo = Object.assign({}, item);
      
      this.fechaMin = this.selectedGrupo.fechainicio;
      this.fechaMax = this.selectedGrupo.fechafinal;

      this.cargar = true;
      this.listaalumnos = [];

      // Preparar payload para obtener los alumnos con estado de asistencia
      let payload = {
        fecha: this.fecha_asistencia,
        idgrupos: this.selectedGrupo.idgrupos,
        lunes: this.selectedGrupo.lunes,
        martes: this.selectedGrupo.martes,
        miercoles: this.selectedGrupo.miercoles,
        jueves: this.selectedGrupo.jueves,
        viernes: this.selectedGrupo.viernes,
        sabado: this.selectedGrupo.sabado,
        domingo: this.selectedGrupo.domingo,
        fechainicio: this.selectedGrupo.fechainicio,
        fechafinal: this.selectedGrupo.fechafinal
      };

      // Obtener alumnos con su estado de asistencia para la fecha seleccionada
      return this.$http.post('grupos.alumnos.asistencia', payload).then(response => {
        this.listaalumnos = response.data;
        this.cargar = false;
        this.dialogAlumnosAsistencia = true;
      }).catch(error => {
        this.validarError(error);
      }).finally(() => { this.cargar = false; });
    },

    enviarAsistencias() {
      this.cargar = true;

      // Preparar payload para enviar asistencias
      const payload = {
        idgrupos: this.selectedGrupo.idgrupos,
        idmaestros: this.getdatosUsuario.id,
        alumnos: this.listaalumnos,
        fecha_asistencia: this.fecha_asistencia
      };

      // Enviar asistencias
      this.$http.post('grupos.asistencia.add', payload).then(response => {
        this.validarSuccess('Asistencia actualizada');
        this.alumnosAsistencia(this.selectedGrupo);
        this.cargar = false;
      }).catch(error => {
        this.validarError(error);
      }).finally(() => { this.cargar = false; });
    }
  }
}
</script>

<style scoped>
.shadowCard {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}
</style>